export default __webpack_public_path__ + "static/media/close_question_2.3aac69d1.svg";